import CreateWatchListEntryPage from './CreateWatchListEntryPage';

export default CreateWatchListEntryPage;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/pages/create-watch-list-entry-page/index.js